export default __webpack_public_path__ + "static/media/bbpsLogo2.228bf641.png";